import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { regionAlertSpecs } from 'root/main/components/regionAlert/regionAlert';

function AlertPopupController(el) {
    this.el = el;
    this.showCSSClass = 'js-alert-popup-show';
    this.hideCSSClass = 'js-alert-popup-hide';
    this.nullCSSClass = 'js-alert-popup-null';
    this.titleElement = el.querySelector('[data-alert-popup-text=title]');
    this.cm = new CookieMonster();
    this.cookieParamId = this.el.dataset.alertPopup;
    this.hasAlertPopupTakenOver = false;
    this.regionAlertCookieName = regionAlertSpecs().getCookieName();
}

AlertPopupController.prototype = {
    postInsertActions() {
        this.setCookie();
        this.el.classList.remove(this.nullCSSClass);
        this.el.classList.add(this.showCSSClass);
        this.takeOverRegionAlert();
    },

    postClosedActions() {
        this.el.classList.remove(this.showCSSClass);
        this.el.classList.add(this.hideCSSClass);
        this.el.addEventListener('animationend', e => {
            e.currentTarget.classList.add(this.nullCSSClass);
        });
        this.restoreSettingRegionAlert();
    },

    takeOverRegionAlert() {
        // if region alert should be shown
        if (this.isHomepage() && !this.isRegionAlertCookieSet()) {
            this.hasAlertPopupTakenOver = true;
            // set the cookie so it will not be shown
            this.setRegionAlertCookie();
        }
    },

    restoreSettingRegionAlert() {
        if (
            this.isHomepage() &&
            this.isRegionAlertCookieSet() &&
            this.hasAlertPopupTakenOver
        ) {
            // remove the region alert cookie only if it has been set by the popup
            this.removeRegionAlertCookie();
        }
    },

    /**
     * Check if current page is homepage
     * @returns {boolean}
     */
    isHomepage() {
        return window.location.pathname === '/';
    },

    isRegionAlertCookieSet() {
        return this.cm.getCookie(this.regionAlertCookieName);
    },

    setRegionAlertCookie() {
        this.cm.setCookie(
            this.regionAlertCookieName,
            regionAlertSpecs().getCookieValue(),
            regionAlertSpecs().getCookieExpirationDate()
        );
    },

    removeRegionAlertCookie() {
        this.cm.unsetCookie(this.regionAlertCookieName);
    },

    closeHandler(e) {
        if (e.target === this.el || e.target.hasAttribute('data-alert-popup-button'))
            e.preventDefault();
        // hide the banner after the close button is clicked
        this.postClosedActions();
    },

    /**
     * @param cookieName
     * @returns {boolean}
     */
    hasCookie(cookieName) {
        return cookieName && this.cm.getCookie(cookieName) === 1;
    },

    /**
     * @returns {string}
     */
    getCookieName() {
        return this.cookieParamId && `_ls-alert-popup-${this.cookieParamId}`;
    },

    setCookie() {
        window.registerCookieComplianceCallback({
            callback: () => this.cm.setCookie(this.getCookieName(), 1, 90),
            isCallOptanonWrapper: true,
        });
    },

    addEventListenerToElement() {
        this.el.addEventListener('click', this.closeHandler.bind(this));
    },

    init() {
        if (!this.hasCookie(this.getCookieName())) {
            this.addEventListenerToElement();
            this.postInsertActions();
        }
    },
};

export default function AlertPopup(els) {
    els.forEach(el => {
        if (el) {
            const alertPopup = new AlertPopupController(el);
            alertPopup.init();
        }
    });
}
